// src/patchResizeObserver.js
// 1) Filtrar globalmente los errores de ResizeObserver loop
window.addEventListener('error', e => {
  if (
    e.message &&
    e.message.includes('ResizeObserver loop completed')
  ) {
    e.stopImmediatePropagation();
  }
});

/*
// 2) Monkey-patch ResizeObserver para suprimir excepciones internas
const _RO = window.ResizeObserver;
if (_RO) {
  window.ResizeObserver = class ResizeObserver {
    constructor(callback) {
      this._ro = new _RO((entries, observer) => {
        try {
          callback(entries, observer);
        } catch {
          // Ignorar errores de loop
        }
      });
    }
    observe(element)   { this._ro.observe(element); }
    unobserve(element) { this._ro.unobserve(element); }
    disconnect()       { this._ro.disconnect(); }
  };
}
*/

//NUEVO!!!
// patchResizeObserver.js
const _RO = window.ResizeObserver;
if (_RO) {
  window.ResizeObserver = class ResizeObserver {
    constructor(callback) {
      this._ro = new _RO((entries, observer) => {
        // Envolvemos TODO en requestAnimationFrame:
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch {
            // Silenciamos cualquier excepción interna al callback
          }
        });
      });
    }
    observe(element)   { this._ro.observe(element); }
    unobserve(element) { this._ro.unobserve(element); }
    disconnect()       { this._ro.disconnect(); }
  };
}
